import { useEffect } from 'react';

function ExampleComponent() {
    useEffect(() => {
        // Code here will run after every render by default
        console.log('Component rendered or updated');

        // Optional cleanup mechanism
        return () => {
            console.log('Cleanup on component unmount or before next re-render');
        };
    });
}

export default ExampleComponent